import React, { useState, useEffect } from 'react';

interface IProps {
	[key: string]: any;
}

const useSetState = (initialState: IProps = {}) => {
	const [state, setState] = useState(initialState);

	useEffect(() => {
		//
	}, []);

	return {
		state,
		setState: $ =>
			setState({ ...state, ...(typeof $ === 'function' ? $(state) : $) }),
	};
};

export default useSetState;
